var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImdb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 36,
    height: 18,
    viewBox: "0 0 36 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POKavaA5FW1pzJptF-d4wjo8pCUFNqTTfuHtM32Q_byjLrk7Kbf-Q5VFvQqAraJfo28X4bzr7wc90LSPKPhWXs4Ph4jf6touxdWgdeEGTPHrN4UunW9qK8-YrlnwfFz0p0fCxXt01_DTK6z6lkbQwQ 1",
    clipPath: "url(#clip0_0_209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.34191 3.61702H7.19875V14.5258H4.34191V3.61702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.5969 8.64196C12.3514 6.9794 12.215 6.05527 12.188 5.87082C12.0685 4.98085 11.9545 4.2064 11.8456 3.5456H8.14163V14.4544H10.6441L10.6529 7.25142L11.7059 14.4544H13.4884L14.487 7.09119L14.4964 14.4544H16.9907V3.5456H13.2586L12.5969 8.64196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.7071 5.81493C21.7384 5.95404 21.7546 6.26954 21.7546 6.76265V10.992C21.7546 11.718 21.7071 12.1627 21.6125 12.3267C21.5174 12.4906 21.2644 12.572 20.8543 12.572V5.41124C21.1655 5.41124 21.3777 5.44416 21.4904 5.50875C21.6031 5.57396 21.6758 5.67581 21.7071 5.81493ZM22.9974 14.3432C23.3374 14.2693 23.6229 14.1389 23.8545 13.9532C24.0856 13.7669 24.2477 13.5092 24.3404 13.1794C24.4337 12.8502 24.4888 12.1963 24.4888 11.2181V7.38743C24.4888 6.35524 24.4481 5.66339 24.3848 5.31187C24.321 4.95974 24.1626 4.63989 23.909 4.35297C23.6548 4.06604 23.2842 3.85985 22.7971 3.7344C22.3094 3.60894 21.5142 3.5456 20.1312 3.5456H18V14.4544H21.461C22.2586 14.4296 22.7708 14.3929 22.9974 14.3432V14.3432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M29.098 12.713C29.0454 12.8515 28.815 12.9216 28.641 12.9216C28.4707 12.9216 28.3574 12.8546 28.2998 12.7198C28.2422 12.5857 28.214 12.2795 28.214 11.8V8.91709C28.214 8.42025 28.239 8.11034 28.2897 7.98675C28.3398 7.8644 28.45 7.8023 28.6203 7.8023C28.7944 7.8023 29.0279 7.87248 29.088 8.01346C29.1475 8.15444 29.1775 8.45565 29.1775 8.91709V11.7125C29.1594 12.2869 29.1331 12.6204 29.098 12.713ZM25.4617 14.3594H28.0337C28.1407 13.9427 28.1996 13.711 28.2115 13.6644C28.4444 13.9439 28.7005 14.1538 28.9816 14.2929C29.2614 14.4327 29.6803 14.5022 30.0046 14.5022C30.456 14.5022 30.8454 14.3848 31.1741 14.1495C31.5022 13.9147 31.7113 13.6365 31.8002 13.3166C31.8891 12.9962 31.9336 12.5093 31.9336 11.8547V8.79412C31.9336 8.1358 31.9185 7.70604 31.8891 7.50419C31.8597 7.30235 31.772 7.09678 31.6262 6.88624C31.4803 6.67571 31.268 6.51237 30.9901 6.39561C30.7121 6.27885 30.384 6.22047 30.0058 6.22047C29.6771 6.22047 29.2564 6.28568 28.9759 6.41424C28.6961 6.5428 28.4419 6.73781 28.214 6.99928V3.45057H25.4617V14.3594V14.3594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImdb);
export default __webpack_public_path__ + "static/media/imdb.7d3b282b57ea78204f038d6ccef45deb.svg";
export { ForwardRef as ReactComponent };